import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { Spacer } from 'emrn-design/Spacer';
import { isIPad } from 'emrn-design/isIPad';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, ImageBackground, Image } from 'react-native';

interface Props {
  onPress?: Function;
}
type awardInfo = {
  title: string;
  rewardType: number;
  uri: string;
};

interface State {
  isShow: boolean;
  text: string;
  awardInfo: awardInfo;
}

export class OpenRedBagPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      text: '',
      awardInfo: {
        title: '',
        rewardType: 0,
        uri: '',
      },
    };
  }

  show = (awardInfo: awardInfo) => {
    this.setState({ isShow: true, awardInfo: awardInfo });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow, awardInfo } = this.state;
    return (
      <>
        {isShow ? (
          <>
            <Mask backgroundColor={'rgba(0,0,0,0.4)'}>
              <View style={styles.content}>
                <View style={styles.main}>
                  <ImageBackground
                    source={require('../../images/invite/awardDia.png')}
                    style={styles.main}
                    resizeMode={'stretch'}
                  >
                    <Spacer size={isIPad ? rpx(80) : rpx(100)} />
                    <View style={{ alignItems: 'center' }}>
                      {[1, 2].includes(awardInfo.rewardType) ? (
                        <>
                          <Image source={{ uri: awardInfo.uri }} style={styles.giftImg} resizeMode={'stretch'} />
                          <Text style={styles.textNoRed}>
                            {awardInfo.title === '随机奖品' ? '1积分' : awardInfo.title}
                          </Text>
                        </>
                      ) : (
                        <ImageBackground
                          style={styles.iconImg}
                          source={require('../../images/invite/redPackageBg.png')}
                          resizeMode={'stretch'}
                        >
                          <Text style={styles.text1}>{awardInfo.title}</Text>
                        </ImageBackground>
                      )}
                    </View>
                    <Spacer size={isIPad ? rpx(20) : rpx(37)} />
                    <EmTouchableOpacity
                      style={styles.iKnow}
                      activeOpacity={0.9}
                      onPress={() => {
                        onPress && onPress();
                        this.hide();
                      }}
                    >
                      <Image
                        style={styles.iKnow}
                        source={require('../../images/invite/iKnow.png')}
                        resizeMode={'stretch'}
                      />
                    </EmTouchableOpacity>
                  </ImageBackground>
                </View>
              </View>
            </Mask>
          </>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iKnow: {
    width: rpx(210),
    height: rpx(52),
  },
  giftImg: {
    width: rpx(120),
    height: rpx(117),
  },
  main: {
    width: rpx(300),
    height: rpx(394),
    alignItems: 'center',
    justifyContent: 'center',
    padding: rpx(25),
  },
  text: {
    fontSize: rpx(24),
    color: '#3A5DD7',
  },
  text1: {
    marginTop: rpx(35),
    textAlign: 'center',
    fontSize: rpx(25),
    color: '#FF222D',
  },
  text2: {
    fontSize: rpx(15),
    color: '#333333',
  },
  text3: {
    fontSize: rpx(15),
    color: '#3A5DD7',
  },
  textNoRed: {
    marginTop: rpx(10),
    fontSize: rpx(14),
    color: '#FF222D',
    textAlign: 'center',
  },
  iconImg: {
    width: rpx(124),
    height: rpx(131),
    zIndex: 11,
  },
  closeImg: {
    width: rpx(12),
    height: rpx(12),
  },
  btnText: {
    fontSize: rpx(16),
    color: '#ffffff',
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
});
